export { default as posthog } from "posthog-js";

export const AnalyticsEvent = {
  SONG_REGION_LOADED: "song_region_loaded",
  SONG_WAVEFORM_GENERATED: "song_waveform_generated",
  SONG_LOAD_COMPLETED: "song_load_completed",
  AUDIO_BACKEND_SELECTED: "audio_backend_selected",
  AUDIO_STREAMING_FATAL_ERROR: "audio_streaming_fatal_error",
  AUDIO_STREAMING_TIMELINE_OVERLAP: "audio_streaming_timeline_overlap",
  SONG_PLAYED: "song_played",
  SONG_PAUSED: "song_paused",
  SONG_STOPPED: "song_stopped",
  SONG_VIEW_REGISTERED: "song_view_registered",
  MARKER_CREATED: "marker_created",
  MARKER_DELETED: "marker_deleted",
  MARKER_RENAMED: "marker_renamed",
  MARKER_JUMPED_TO: "marker_jumped_to",
  PLAYLIST_CREATED: "playlist_created",
  PLAYLIST_RENAMED: "playlist_renamed",
  PLAYLIST_DELETED: "playlist_deleted",
  PLAYLIST_COVER_UPLOADED: "playlist_cover_uploaded",
  PLAYLIST_COVER_REMOVED: "playlist_cover_removed",
  PLAYLIST_SHARING_TOGGLED: "playlist_sharing_toggled",
  PLAYLIST_SHARING_RESET: "playlist_sharing_reset",
  SONG_RENAMED: "song_renamed",
  SONG_DELETED: "song_deleted",
  SONG_SHARING_TOGGLED: "song_sharing_toggled",
  SONG_SHARING_RESET: "song_sharing_reset",
  SONG_ADDED_TO_PLAYLIST: "song_added_to_playlist",
  SONG_REMOVED_FROM_PLAYLIST: "song_removed_from_playlist",
  UPLOAD_TRACK_SELECTED: "upload_track_selected",
  UPLOAD_SUBMITTED: "upload_submitted",
  UPLOAD_TRANSCODE_COMPLETED: "upload_transcode_completed",
  UPLOAD_TRANSCODE_FAILED: "upload_transcode_failed",
  UPLOAD_COMPLETED: "upload_completed",
  USER_REGISTERED: "user_registered",
  USER_SIGNED_IN: "user_signed_in",
  ACCOUNT_PROFILE_UPDATED: "account_profile_updated",
  ACCOUNT_PASSWORD_UPDATED: "account_password_updated",
  SUPPORT_TICKET_OPENED: "support_ticket_opened",
  TRACK_DELETED: "track_deleted",
  TRACK_RENAMED: "track_renamed",
  SONG_CREATED: "song_created",
  RECORDING_STARTED: "recording_started",
  RECORDING_STOPPED: "recording_stopped",
  RECORDING_SAVED: "recording_saved",
  TRACK_CREATED: "track_created",
  TRACKS_ADDED_WITH_FILES: "tracks_added_with_files",
  HOTKEY_USED: "hotkey_used",
  INPUT_DEVICE_CHANGED: "input_device_changed",
  PLAYBACK_RATE_CHANGED: "playback_rate_changed",
  PLAYBACK_TRANSPOSED: "playback_transposed",
  EMBED_SONG_CLICKED: "embed_song_clicked",
  EMBED_CODE_COPIED: "embed_code_copied",
  EARLY_ACCESS_FEATURE_ENROLLED: "early_access_feature_enrolled",
  EARLY_ACCESS_FEATURE_UNENROLLED: "early_access_feature_unenrolled",
  MOBILE_MARKERS_TOGGLED: "mobile_markers_toggled",
  MOBILE_SETTINGS_TOGGLED: "mobile_settings_toggled",
  ZOOM_CHANGED: "zoom_changed",
} as const;
